import { AxiosInstance } from 'axios'

import { AccountsApiFactory } from '../generated/credit-api'

// TO EXTEND: When adding new credit-api endpoints, follow these steps:
//
// 1. Import the new API factory:
//    import { AccountsApiFactory } from '../generated/credit-api'
//
// 2. Add a domain parameter:
//    export const creditApiDefaultApiFactory = (instance: AxiosInstance, domain?: string) => {
//
// 3. Add switch logic to handle multiple APIs:
//
// 4. Update the hygen template to pass the repository name as domain parameter

/**
 * Credit API factory - currently only using AccountsApi for /v1/accounts/connection-status endpoint
 * This simple implementation follows the YAGNI principle - we only build what we need now.
 * See comments above for step-by-step extension guide when adding new endpoints.
 */
export const creditApiDefaultApiFactory = (instance: AxiosInstance) => {
  return AccountsApiFactory(undefined, '', instance)
}
